// this file is automatically generated by git-version script
export const version = {
  name: 'amg-provider-client',
  version: '1.56.0',
  commit: '51f973c29cbe205fba13f3750c9893ad5ffb4b1b',
  branch: 'platinum',
  dateGenerated: '2025-12-03T08:07:33.244Z',
};